module.exports = __webpack_public_path__ + "img/domicaliz.62731169.png";